import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

import ConditionsTextBlock from '../ConditionsTextBlock/ConditionsTextBlock';

import { getVariantItemValue } from './utils/getVariantItemValue';
import { VariantItemWrapper } from './styles/VariantItemWrapper';
import { VariantItemsWrapper } from './styles/VariantItemsWrapper';
import { Section } from './styles/Section';

const ConditionsSectionVariant = ({ variants, interest }) => {
  const { formatMessage } = useIntl();
  const interestRateProps = interest ? {
    ...interest,
  } : {
    month: '',
    year: '',
    rate_value: 0,
  };
  return (
    <>
      <Section>
        {variants.map(({
          id, title, variantCostsLink, items,
        }) => (
          <Box
            width="100%"
            maxWidth="1328px"
            tag="article"
            paddingTop="24px"
          >
            <Box
              width="100%"
              tag="div"
              gap="x2"
            >
              <Box
                justifyContent="center"
                display="flex"
                alignItems="center"
                borderRadius="50%"
                backgroundColor="#EFEFEF"
                width="48px"
                height="48px"
                padding="10px"
                gap="10px"
              >
                <Typography
                  strong
                  fontSize="24px"
                  color="black"
                  variant="heading4"
                >
                  {id}
                </Typography>
              </Box>

              <Typography
                tag="h3"
                color="black"
                variant="heading3"
                marginBottom={spacing('2x')}
                marginTop={spacing('2x')}
                intlKey={title}
              />

              <VariantItemsWrapper key={id}>
                {items.map(({
                  itemId,
                  itemTitle,
                  itemSummary,
                  itemValueType,
                  itemValue,
                  itemIsDiscount,
                  itemDiscountType,
                }) => (
                  <VariantItemWrapper key={itemId}>
                    <Box
                      tag="div"
                      width="100%"
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                    >
                      <Typography
                        strong
                        color="black.default"
                        variant="paragraph1"
                        intlKey={itemTitle}
                        intlValues={{
                          ...interestRateProps,
                          discount: itemValue,
                        }}
                      />
                      <Typography
                        strong
                        color="black.default"
                        variant="paragraph1"
                        intlKey={
                          itemValueType === 'CURRENCY'
                            ? 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.VALUE_CURRENCY'
                            : 'CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.VALUE_PERCENTAGE'
                        }
                        intlValues={{
                          value: getVariantItemValue(
                            itemValueType,
                            itemValue,
                            itemIsDiscount,
                            itemDiscountType,
                            parseFloat(interestRateProps.rate_value),
                          ),
                        }}
                      />
                    </Box>
                    <Box
                      tag="div"
                      width="100%"
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                    >
                      <Typography
                        color="black.default"
                        variant="paragraph2"
                        flexDirection="column"
                        intlKey={itemSummary}
                      />
                    </Box>
                  </VariantItemWrapper>
                ))}
              </VariantItemsWrapper>

              <ConditionsTextBlock
                textIntlKey="CREDIT_CARD.CONDITIONS.RATES.MASTERCARD_BENEFITS_VALUE"
                textIntlValues={{
                  link: (
                    <Link
                      href={formatMessage({ id: variantCostsLink })}
                      intlKey="CREDIT_CARD_NU_CONTROL.CONDITIONS.VARIANTS.LINK_TITLE"
                      typographyProps={{ variant: 'paragraph1' }}
                      variant="action"
                      iconProps={{ name: 'arrow-up-right', size: 'small' }}
                      color="primary"
                      rel="noopener"
                      target="_blank"
                    />
                  ),
                }}
              />
            </Box>
          </Box>
        ))}
      </Section>
    </>
  );
};

ConditionsSectionVariant.defaultProps = {
  interest: {},
};

ConditionsSectionVariant.propTypes = {
  interest: PropTypes.shape({
    month: PropTypes.string,
    rate_value: PropTypes.string,
    year: PropTypes.string,
  }),
  variants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ConditionsSectionVariant;
